import { render, staticRenderFns } from "./AlertUpdate.vue?vue&type=template&id=49f18f87&scoped=true"
import script from "./AlertUpdate.vue?vue&type=script&lang=js"
export * from "./AlertUpdate.vue?vue&type=script&lang=js"
import style0 from "./AlertUpdate.vue?vue&type=style&index=0&id=49f18f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f18f87",
  null
  
)

export default component.exports